import { render, staticRenderFns } from "./assignTrench.vue?vue&type=template&id=5ba120de&"
import script from "./assignTrench.vue?vue&type=script&lang=js&"
export * from "./assignTrench.vue?vue&type=script&lang=js&"
import style0 from "./assignTrench.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports